exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zip-file-download[data-v-0f9ea59a]{margin:20px 0}.zip-file-download__button[data-v-0f9ea59a]{font-size:16px;font-weight:700;text-align:center;text-transform:none;width:100%}.zip-file-download__button-label--uppercase[data-v-0f9ea59a]{text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f9ea59a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//node_modules//bootstrap-sass//assets//stylesheets//bootstrap//_variables.scss","D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//WebResources//vue//shared//scss//_variables.scss","D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//WebResources//vue//shared//scss//_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./WebResources/vue/grad-images/checkout-download/components/Photos/ZipFileDownload.vue
// module id = 1639
// module chunks = 3